'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PushService = function () {
  function PushService(authService, appConfig, notificationService, $state, $rootScope, enquiryService, enums, $ngConfirm) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, PushService);
    this.authService = authService;
    this.notificationService = notificationService;
    this.connection = $.hubConnection(appConfig.apiServiceBaseUri);
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.enquiryService = enquiryService;
    this.enums = enums;
    this.$ngConfirm = $ngConfirm;

    //Add Enquiry Notification Handlers in Root scope
    this.$rootScope.enquiryAcceptedByUser = this.enquiryAcceptedByUser.bind(this);
    this.$rootScope.enquiryRejectedByUser = this.enquiryRejectedByUser.bind(this);
    this.$rootScope.enquiryHeldByUser = this.enquiryHeldByUser.bind(this);

    this.messageHub = {
      enquiryCreated: function enquiryCreated(enquiryId, receiverId, senderId) {
        _this.messageHubProxy.invoke('enquiryCreated', enquiryId, receiverId, senderId);
      },
      existingEnquiry: function existingEnquiry(enquiryId, receiverId, senderId, contactName, contactMethod) {
        _this.messageHubProxy.invoke('existingEnquiry', enquiryId, receiverId, senderId, contactName, contactMethod);
      },
      enquiryDeclined: function enquiryDeclined(enquiryId, userId) {
        _this.messageHubProxy.invoke('enquiryDeclined', enquiryId, userId);
      },
      enquiryAccepted: function enquiryAccepted(enquiryId, userId) {
        _this.messageHubProxy.invoke('enquiryAccepted', enquiryId, userId);
      },
      enquiryHeld: function enquiryHeld(enquiryId, userId) {
        _this.messageHubProxy.invoke('enquiryHeld', enquiryId, userId);
      },
      sendMessage: function sendMessage(userIds, msg) {
        _this.messageHubProxy.invoke('sendMessage', userIds, msg);
      },
      enquiryCreatedFromWebEnquiry: function enquiryCreatedFromWebEnquiry(userId, enquiryId, senderName) {
        _this.messageHubProxy.invoke('enquiryCreatedFromWebEnquiry', userId, enquiryId, senderName);
      },
      signatureEvent: function signatureEvent(enquiryId, contactName, newStatus) {
        _this.messageHubProxy.invoke('signatureEvent', enquiryId, contactName, newStatus);
      }
    };

    this.hubProxy = this.connection.createHubProxy('messageHub');
  }

  (0, _createClass3.default)(PushService, [{
    key: 'init',
    value: function init() {
      var svc = this;

      if (svc.connection.state === 1 || svc.connection.state === 0 || !svc.authService.authData.userId) {
        //Push Service is already connected, dont do anything
        return;
      }

      svc.initMessageHub();

      svc.connection.start({ jsonp: true }).done(function () {
        svc.messageHubProxy.invoke('subscribe', svc.authService.authData.userId);
        console.log('Now connected, connection ID=' + svc.connection.id);
      }).fail(function (e) {
        console.log('Could not connect', e);
      });
    }
  }, {
    key: 'initMessageHub',
    value: function initMessageHub() {
      this.messageHubProxy = this.connection.createHubProxy('messageHub');

      this.messageHubProxy.on('notifyEnquiryCreated', this.notifyEnquiryCreatedHandler.bind(this));
      this.messageHubProxy.on('notifyExistingEnquiryOpened', this.notifyExistingEnquiryOpened.bind(this));
      this.messageHubProxy.on('notifySendMessage', this.notifySendMessage.bind(this));
      this.messageHubProxy.on('notifyWebEnquiriesCreated', this.notifyWebEnquiriesCreatedHandler.bind(this));
      this.messageHubProxy.on('notifyEnquiryCreatedFromWebEnquiry', this.notifyEnquiryCreatedFromWebEnquiryHandler.bind(this));
      this.messageHubProxy.on('notifyEnquiryQuotationViewed', this.notifyEnquiryQuotationViewed.bind(this));
      this.messageHubProxy.on('notifyFinanceCreated', this.notifyFinanceCreated.bind(this));
      this.messageHubProxy.on('signatureEvent', this.signatureEvent.bind(this));
    }
  }, {
    key: 'registerEnquiryDeclinedHandler',
    value: function registerEnquiryDeclinedHandler(handler) {
      this.messageHubProxy.on('notifyEnquiryDeclined', handler);
    }
  }, {
    key: 'registerEnquiryAcceptedHandler',
    value: function registerEnquiryAcceptedHandler(handler) {
      this.messageHubProxy.on('notifyEnquiryAccepted', handler);
    }
  }, {
    key: 'registerEnquiryHeldHandler',
    value: function registerEnquiryHeldHandler(handler) {
      this.messageHubProxy.on('notifyEnquiryHeld', handler);
    }
  }, {
    key: 'registerEnquiryCreatedHandler',
    value: function registerEnquiryCreatedHandler(handler) {
      debugger;
      this.messageHubProxy.on('notifyEnquiryCreated', handler);
    }
  }, {
    key: 'registerExistingEnquiryOpenedHandler',
    value: function registerExistingEnquiryOpenedHandler(handler) {
      this.messageHubProxy.on('notifyExistingEnquiryOpened', handler);
    }
  }, {
    key: 'notifyExistingEnquiryOpened',
    value: function notifyExistingEnquiryOpened(enquiryId, senderId, contactName, contactMethod) {
      this.authService.authData.msgCount++;
      var scope = this.$rootScope.$new();
      scope.enquiryId = enquiryId;
      scope.senderId = senderId;

      var header = 'Enquiry Alert';
      var msgBody = '';

      switch (contactMethod) {
        case this.enums.ENQUIRY_ORIGINATION.WalkIn:
          msgBody = contactName + ' requires your attention in the showroom';
          break;

        case this.enums.ENQUIRY_ORIGINATION.Phone:
          msgBody = contactName + ' is on the phone looking to speak to you ';
          break;

        case this.enums.ENQUIRY_ORIGINATION.Email:
          msgBody = contactName + ' has sent an e mail and is looking for you to contact them';
          break;

        case this.enums.ENQUIRY_ORIGINATION.Web:
          msgBody = contactName + ' has sent a message through Web and is looking for you to contact them';
          break;
      }

      scope.header = header;
      scope.msgBody = msgBody;

      this.notificationService.showEnquiryNotification(scope, 'existingEnquiryTemplate');
    }
  }, {
    key: 'notifyEnquiryCreatedHandler',
    value: function notifyEnquiryCreatedHandler(enquiryId, senderId) {
      this.authService.authData.msgCount++;
      var scope = this.$rootScope.$new();
      scope.enquiryId = enquiryId;
      scope.senderId = senderId;
      this.notificationService.showEnquiryNotification(scope, 'enquiryNotificationTemplate');
    }
  }, {
    key: 'notifyEnquiryCreatedFromWebEnquiryHandler',
    value: function notifyEnquiryCreatedFromWebEnquiryHandler(enquiryId, sender) {
      var scope = this.$rootScope.$new();
      scope.enquiryId = enquiryId;
      scope.sender = sender;
      this.notificationService.showEnquiryNotification(scope, 'enquiryFromWebEnquiryTemplate');
    }
  }, {
    key: 'viewMessage',
    value: function viewMessage(messageId) {
      this.authService.authData.msgCount--;
      this.$state.go('messageView', { messageId: messageId });
    }
  }, {
    key: 'enquiryAcceptedByUser',
    value: function enquiryAcceptedByUser(enquiryId, senderId) {
      var _this2 = this;

      this.enquiryService.updateOwner(enquiryId, this.authService.authData.userId).then(function () {
        _this2.messageHub.enquiryAccepted(enquiryId, senderId);
        _this2.$state.go('enquiryEdit', { enquiryId: enquiryId });
      });
    }
  }, {
    key: 'enquiryHeldByUser',
    value: function enquiryHeldByUser(enquiryId, senderId) {
      this.messageHub.enquiryHeld(enquiryId, senderId);
    }
  }, {
    key: 'enquiryRejectedByUser',
    value: function enquiryRejectedByUser(enquiryId, senderId) {
      this.messageHub.enquiryDeclined(enquiryId, senderId);
    }
  }, {
    key: 'notifySendMessage',
    value: function notifySendMessage(msg) {
      this.authService.authData.msgCount++;
      var scope = this.$rootScope.$new();
      scope.header = 'New Message Received';
      scope.msg = msg;
      this.notificationService.showEnquiryNotification(scope, 'sendMessageTemplate');
    }
  }, {
    key: 'notifyWebEnquiriesCreatedHandler',
    value: function notifyWebEnquiriesCreatedHandler(entityId, count) {
      var _this3 = this;

      console.log('entityId', entityId);
      var scope = this.$rootScope.$new();
      scope.count = count;

      scope.viewDashoard = function () {
        if (_this3.authService.authData.currentLocation.key !== entityId) {
          _this3.$ngConfirm({
            title: "Warning",
            content: 'The section you\'re trying to navigate is not in your currently selected location.<br><br>If you wish to proceed, your selected location will be updated',
            type: 'orange',
            columnClass: 'l',
            buttons: {
              ok: {
                text: 'Proceed',
                btnClass: 'btn-primary',
                action: function action() {
                  _this3.authService.updateLocationById(entityId);
                  _this3.$state.go('dashboard', {}, { reload: true });
                }
              },
              cancel: {
                text: 'Not sure',
                btnClass: 'btn-default',
                action: function action() {}
              }
            }
          });
        } else {
          _this3.$state.go('dashboard', {}, { reload: true });
        }
      };

      this.notificationService.showEnquiryNotification(scope, 'webEnquiriesCreatedTemplate');
    }
  }, {
    key: 'notifyEnquiryQuotationViewed',
    value: function notifyEnquiryQuotationViewed(enquiryId) {
      var scope = this.$rootScope.$new();
      scope.enquiryId = enquiryId;
      this.notificationService.showEnquiryNotification(scope, 'enquiryQuoteViewedTemplate');
      this.authService.authData.msgCount += 1;
    }
  }, {
    key: 'notifyFinanceCreated',
    value: function notifyFinanceCreated(financeId) {
      var scope = this.$rootScope.$new();
      scope.financeId = financeId;
      this.notificationService.showEnquiryNotification(scope, 'financeCreatedTemplate');
      this.authService.authData.msgCount += 1;
    }
  }, {
    key: 'signatureEvent',
    value: function signatureEvent(enquiryId, contactName, newStatus) {
      this.authService.authData.msgCount++;
      var scope = this.$rootScope.$new();
      scope.enquiryId = enquiryId;

      switch (newStatus) {
        case this.enums.SIGNATURE_STATUS.Voided:
          scope.msg = 'The signature request has been voided by the Admin';
          break;

        case this.enums.SIGNATURE_STATUS.CustomerDeclined:
          scope.msg = contactName + ' has declined to sign the Order Form';
          break;

        case this.enums.SIGNATURE_STATUS.CustomerSigned:
          scope.msg = contactName + ' has signed the Order Form';
          break;

        case this.enums.SIGNATURE_STATUS.DealerDeclined:
          scope.msg = 'You have declined to sign the Order Form';
          break;

        case this.enums.SIGNATURE_STATUS.Completed:
          scope.msg = 'The order form signatures have been completed';
          break;
      }

      this.notificationService.showEnquiryNotification(scope, 'signatureEventTemplate');
    }
  }]);
  return PushService;
}();

exports.default = PushService;


// WEBPACK FOOTER //
// ./client/app/common/services/pushService.js